import { AppSidebar } from "@/components/app-sidebar";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Separator } from "@/components/ui/separator";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { breadcrumb$ } from "@/state/breadcrumb.state";
import type { ReactNode } from "react";

export default function Layout({ children }: { children: ReactNode }) {
  const breadcrumbItems = breadcrumb$.items.use();
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator
              orientation="vertical"
              className="mr-2 data-[orientation=vertical]:h-4"
            />
            <Breadcrumb>
              <BreadcrumbList>
                {breadcrumbItems.map((item, index) => {
                  if (index === breadcrumbItems.length - 1) {
                    return (
                      <BreadcrumbItem key={`${index}-item`}>
                        <BreadcrumbPage>{item}</BreadcrumbPage>
                      </BreadcrumbItem>
                    );
                  } else {
                    return [
                      <BreadcrumbItem key={`${index}-item`}>
                        <BreadcrumbLink href="#">{item}</BreadcrumbLink>
                      </BreadcrumbItem>,
                      <BreadcrumbSeparator
                        className="hidden md:block"
                        key={`${index}-separator`}
                      />,
                    ];
                  }
                })}
              </BreadcrumbList>
            </Breadcrumb>
          </div>
        </header>
        <div className="flex flex-1 flex-col gap-4 p-4 pt-0">
          {children}
          {/* <div className="bg-muted/50 min-h-[100vh] flex-1 rounded-xl md:min-h-min" /> */}
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}
